import React from "react";

import clsx from "clsx";
import PropTypes from "prop-types";

import RbActionsContext from "components/RbActions/RbActionsContext";

import useStyles from "./RbButtonAction.styles";

export const RbButtonAction = React.forwardRef(function RbButtonAction(
  props,
  ref
) {
  const { Icon, text, onClick, ...other } = props;

  const classes = useStyles();

  const { compacted, insideMore, handleCloseMore, color } = React.useContext(
    RbActionsContext
  );

  const handleClick = (event) => {
    if (insideMore) {
      handleCloseMore();
    }
    if (onClick) {
      onClick(event);
    }
  };

  const rootClassName = clsx({
    [classes.root]: true,
    [classes.root_compacted]: compacted,
    [classes.root_insideMore]: insideMore,
  });

  const iconClassName = clsx({
    [classes.icon]: true,
    [classes.icon_compacted]: compacted,
    [classes[`icon_${color}`]]: true,
  });

  const textClassName = clsx({
    [classes.text]: true,
    [classes.text_compacted]: compacted,
    [classes[`text_${color}`]]: true,
  });

  return (
    <button
      {...other}
      ref={ref}
      className={rootClassName}
      type="button"
      onClick={handleClick}
    >
      {Icon && <Icon fontSize="default" className={iconClassName} />}
      <span className={textClassName}>{text}</span>
    </button>
  );
});

RbButtonAction.propTypes = {
  /** Icon of the button. */
  Icon: PropTypes.object,
  /** Callback when the button is cliked. */
  onClick: PropTypes.func,
  /** The text of the button */
  text: PropTypes.string.isRequired,
};

RbButtonAction.defaultProps = {
  Icon: undefined,
  onClick: undefined,
};

RbButtonAction.displayName = "RbButtonAction";

export default React.memo(RbButtonAction);
